export function generatePlacementPeriods(startYear, startMonth) {
  const numOfMonths = 12;
  const numOfQuarters = 4;
  const placementPeriods = [];
  let monthAddition = 1;
  let nextYear = startYear + 1;

  // Current year calculated by month
  while (startMonth + monthAddition <= numOfMonths) {
    const month = startMonth + monthAddition;
    placementPeriods.push(`${startYear}M${month}`);
    monthAddition += 1;
  }

  for (let yearIterator = 1; yearIterator <= 5; yearIterator += 1) {
    // Next year calculated by quartals
    for (let iterator = 1; iterator <= numOfQuarters; iterator += 1) {
      placementPeriods.push(`${nextYear}Q${iterator}`);
    }
    nextYear += 1;
  }

  return placementPeriods;
}
export function generatePlacementPeriodsCapex(startYear, startMonth) {
  const numOfMonths = 12;
  const numOfQuarters = 4;
  const placementPeriods = [];
  let monthAddition = 1;
  let nextYear = startYear + 1;
  placementPeriods.push(`${startYear}M${startMonth}`);
  // Current year calculated by month
  while (startMonth + monthAddition <= numOfMonths) {
    const month = startMonth + monthAddition;
    placementPeriods.push(`${startYear}M${month}`);
    monthAddition += 1;
  }

  for (let yearIterator = 1; yearIterator <= 5; yearIterator += 1) {
    // Next year calculated by quartals
    for (let iterator = 1; iterator <= numOfQuarters; iterator += 1) {
      placementPeriods.push(`${nextYear}Q${iterator}`);
    }
    nextYear += 1;
  }

  return placementPeriods;
}
export function monthToQ(nextYear, month) {
  const quarters = [3, 6, 9, 12];
  let placementPeriod = `${nextYear}M${month}`;
  if (quarters.includes(month)) {
    placementPeriod = `${nextYear}Q${month / 3}`;
  }

return placementPeriod;
}
export function generatePlacementPeriodsFunding(startYear, startMonth) {
  const numOfMonths = 12;
  const placementPeriods = [];
  let monthAddition = 1;
  let nextYear = startYear + 1;
  placementPeriods.push(`${startYear}M${startMonth}`);
  // Current year calculated by month
  while (startMonth + monthAddition <= numOfMonths) {
    const month = startMonth + monthAddition;
    placementPeriods.push(`${startYear}M${month}`);
    monthAddition += 1;
  }

  for (let yearIterator = 1; yearIterator <= 8; yearIterator += 1) {
    // Next year calculated by quartals
    for (let iterator = 1; iterator <= numOfMonths; iterator += 1) {
      placementPeriods.push(monthToQ(nextYear, iterator));
    }
    nextYear += 1;
  }

  return placementPeriods;
}
